import { OverLayFields } from '../models/OverlayFields';
import { PositioningType } from '../models/PositioningType';

export const TundraSSIPositioning: PositioningType[] = [
  { overlayField: OverLayFields.LastGoodScan, position: { x: 0, y: 0 }, justification: 'left' },
  {
    overlayField: OverLayFields.ApiDesignation,
    position: { x: 0, y: 0 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.RunStatus,
    position: { x: 45, y: 361 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.ControllerType,
    position: { x: 45, y: 391 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.RTUAddress,
    position: { x: 45, y: 427 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.StrokeLength,
    position: { x: 45, y: 463 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.StrokesPerMinute,
    position: { x: 45, y: 500 },
    justification: 'left',
  },
  { overlayField: OverLayFields.TubingPressure, position: { x: 543, y: 481 }, justification: 'left' },
  { overlayField: OverLayFields.FlowlinePressure, position: { x: 543, y: 518 }, justification: 'left' },
  { overlayField: OverLayFields.CasingPressure, position: { x: 543, y: 555 }, justification: 'left' },
  { overlayField: OverLayFields.PumpDepth, position: { x: 543, y: 687 }, justification: 'left' },
  { overlayField: OverLayFields.PumpType, position: { x: 543, y: 723 }, justification: 'left' },
  { overlayField: OverLayFields.RodLoading, position: { x: 543, y: 760 }, justification: 'left' },
];
